import { call, select, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { requestSubscription, requestSubscriptionV2 } from '../api/subscription';
import { getSessionId } from '../selectors/session';
import { getVendorInfo } from '../selectors/vendor';
import { doShowLoading, doHideLoading } from '../actions/ui';
import { doSaveLastDigits } from '../actions/session';
import { postMessageSender } from '../lib/postMessager';
import messages from '../enum/messages';
import { doSaveCurrentCardBrand } from '../actions/brands';

function* handleRequestSubscription(action) {
  yield put(doShowLoading());
  const sessionId = yield select(getSessionId);
  const cpfVendedor = yield select(getVendorInfo);

  const {
    m4uEldoradoBridgeRef, plan,
  } = action.payload;

  try {
    const result = yield m4uEldoradoBridgeRef.current.tokenize();
    const { card } = result;
    yield call(requestSubscription, sessionId, card.key, card.cvv, plan, cpfVendedor);
    yield put(doSaveCurrentCardBrand(card.brand.toLowerCase()));
    yield put(doSaveLastDigits(card.last));
    postMessageSender({
      action: 'executed',
      plano: plan,
    });
    yield put(push('/sucesso'));
  } catch (e) {
    if (e.code !== 400) {
      postMessageSender({
        action: 'execute_failed',
        code: 'BE-001',
        reason: messages.FE_001,
      });
      yield put(push('/error'));
    }
  } finally {
    yield put(doHideLoading());
  }
}

function* handleRequestSubscriptionV2(action) {
  const sessionId = yield select(getSessionId);
  const {
    m4uEldoradoBridgeRef, plan,
  } = action.payload;
  let { input } = action.payload;

  yield put(doShowLoading());

  try {
    if (m4uEldoradoBridgeRef) {
      const result = yield m4uEldoradoBridgeRef.current.tokenize();
      let data;
      const { card } = result;
      if (result.data3ds) {
        data = result.data3ds.params;
      }

      input = {
        ...card,
        data3ds: data,
      };
    } else {
      input = {
        ...input,
        key: action.payload.token,
        last: action.payload.last,
        brand: action.payload.brand,
      }
    }

    const headers = { headers: { 'x-api-key': process.env.REACT_APP_X_API_KEY_BFF }};
    yield call(requestSubscriptionV2, sessionId, input.key, input.cvv, plan, null, input.data3ds, headers);
    yield put(doSaveCurrentCardBrand(input.brand.toLowerCase()));
    yield put(doSaveLastDigits(input.last));
    postMessageSender({
      action: 'executed',
      plano: plan,
    });
    yield put(push('/sucesso-v2'));
  } catch (e) {
    if (e.code !== 400) {
      postMessageSender({
        action: 'execute_failed',
        code: 'BE-001',
        reason: messages.FE_001,
      });
      yield put(push('/error-v2'));
    }
  } finally {
    yield put(doHideLoading());
  }
}

export { handleRequestSubscription, handleRequestSubscriptionV2 };
